import { render, staticRenderFns } from "./ScopeOfWork.vue?vue&type=template&id=926959e0&scoped=true&"
import script from "./ScopeOfWork.vue?vue&type=script&lang=js&"
export * from "./ScopeOfWork.vue?vue&type=script&lang=js&"
import style0 from "./ScopeOfWork.vue?vue&type=style&index=0&id=926959e0&prod&scoped=true&lang=css&"
import style1 from "./ScopeOfWork.vue?vue&type=style&index=1&id=926959e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926959e0",
  null
  
)

export default component.exports